import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

/** Active Google Calendar sync for the current business. */
export function useGoogleCalendarConnection(businessId: string | undefined) {
  const [connected, setConnected] = useState(false);
  const [syncId, setSyncId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!businessId) {
      setConnected(false);
      setSyncId(null);
      setLoading(false);
      return;
    }

    let cancelled = false;

    const check = async () => {
      const { data } = await supabase
        .from('google_calendar_sync')
        .select('id, is_active')
        .eq('business_id', businessId)
        .eq('is_active', true)
        .limit(1)
        .maybeSingle();

      if (cancelled) return;
      setConnected(!!data);
      setSyncId(data?.id ?? null);
      setLoading(false);
    };

    void check();
    return () => {
      cancelled = true;
    };
  }, [businessId]);

  return { connected, syncId, loading };
}
